import { lazy, ReactNode } from 'react'

const BatchDisableUserPage = lazy(
  () =>
    import(
      '@/presentation/pages/internal-company-manager/batch-disable-user/batch-disable-user-page'
    )
)

export const makeBatchDisableUserPage = (): ReactNode => {
  return <BatchDisableUserPage />
}

const InvoicePage = lazy(
  () => import('@/presentation/pages/internal-company-manager/invoice/invoice-event-list-page')
)

export const makeInvoicePage = (): ReactNode => {
  return <InvoicePage />
}

const InvoiceDetailPage = lazy(
  () => import('@/presentation/pages/internal-company-manager/invoice/invoice-event-detail-page')
)

export const makeInvoiceDetailPage = (): ReactNode => {
  return <InvoiceDetailPage />
}

const CompanyDetailPage = lazy(
  () => import('@/presentation/pages/internal-company-manager/company/company-detail-page')
)

export const makeCompanyDetailPage = (): ReactNode => {
  return <CompanyDetailPage />
}

const PartnerDetailPage = lazy(
  () => import('@/presentation/pages/internal-company-manager/partner/partner-detail-page')
)

export const makePartnerDetailPage = (): ReactNode => {
  return <PartnerDetailPage />
}
